import type { PropCategory } from "@circle-react-shared/BuilderUI/DataModel.types";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const getWidthOptions = ({
  defaultValue = "100%",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "dimension",
  value: defaultValue,
});

export const getHeightOptions = ({
  defaultValue = "40px",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "dimension",
  value: defaultValue,
});

export const getMinWidthOptions = ({
  defaultValue = "100px",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "dimension",
  value: defaultValue,
});

export const getMinHeightOptions = ({
  defaultValue = "40px",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "dimension",
  value: defaultValue,
});

export const getMaxWidthOptions = ({
  defaultValue = "100px",
}: {
  defaultValue?: string;
  category?: PropCategory[];
}): StyleValue => ({
  type: "dimension",
  value: defaultValue,
});

export const getMaxHeightOptions = ({
  defaultValue = "40px",
}: {
  defaultValue?: string;
}): StyleValue => ({
  type: "dimension",
  value: defaultValue,
});

export const getSizingOptions = ({
  defaultValue = {
    width: "100%",
    height: "100%",
    minWidth: "100px",
    minHeight: "40px",
    maxWidth: "100px",
    maxHeight: "40px",
  },
}: {
  defaultValue?: {
    width: string;
    height: string;
    minWidth: string;
    minHeight: string;
    maxWidth: string;
    maxHeight: string;
  };
}): StyleValue => ({
  type: "sizing",
  value: defaultValue,
});
